import React, { useCallback, useEffect } from "react";

import Modal from "components/ui/modal/Modal";
import { useFindIntegrationProvider } from "lib/hooks/api/integrations/useFindIntegrationProvider";
import { EventData, EventNames, useTracking } from "lib/tracking";
import { FeatureType } from "../paywallUtils";
import { StrategyPaywallContent } from "./StrategyPaywallContent";

type Props = {
  featureType: FeatureType;
  contextSource?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trackingData?: EventData;
};
function StrategyPaywallModal({
  featureType,
  open,
  contextSource,
  onOpenChange,
  trackingData,
}: Props) {
  const { logEvent } = useTracking();
  // The response, not the type: destructuring `data` under this name sent the whole object —
  // and it now carries the install's extra send-form fields.
  const { data: provider } = useFindIntegrationProvider();
  const providerType = provider?.providerType;

  const trackModalOpen = useCallback(
    (trackingEvent: EventNames) => {
      logEvent(trackingEvent, {
        "Context source": contextSource,
        "Data type": featureType,
        "Connected provider": providerType,
        ...trackingData,
      });
    },
    [contextSource, featureType, logEvent, providerType, trackingData],
  );

  useEffect(() => {
    if (open) trackModalOpen(EventNames.paywallModalOpened);
  }, [open, trackModalOpen]);

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      trackModalOpen(EventNames.paywallModalDismissed);
    }
    onOpenChange(open);
  };

  return (
    <Modal open={open} onOpenChange={handleOpenChange} maxWidth="1200px">
      <StrategyPaywallContent
        featureType={featureType}
        trackingData={trackingData}
        contextSource={contextSource}
      />
    </Modal>
  );
}

export default StrategyPaywallModal;
